import React from "react";
import { Button } from 'react-materialize';
 
export default function BtnCreateNewLeave() {
    return <Button node="button" id="btn-create-new">
        Create a new leave
    </Button>
}